import { FC } from 'react';
import { IconProps, IconColor } from '../types';

export const SuccessIcon: FC<IconProps & { withExternalCircle?: boolean }> = ({
  width = 16,
  height = 16,
  withExternalCircle = false,
  fillColor = IconColor.GREEN,
  ...props
}) => {
  if (withExternalCircle)
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="12" fill={fillColor} fillOpacity="0.15" />
        <path
          d="M10.8333 15.8334L16.7083 9.95841L15.5416 8.79175L10.8333 13.5001L8.45829 11.1251L7.29163 12.2917L10.8333 15.8334ZM12 20.3334C10.8472 20.3334 9.76385 20.1147 8.74996 19.6772C7.73607 19.2397 6.85413 18.6459 6.10413 17.8959C5.35413 17.1459 4.76038 16.264 4.32288 15.2501C3.88538 14.2362 3.66663 13.1529 3.66663 12.0001C3.66663 10.8473 3.88538 9.76397 4.32288 8.75008C4.76038 7.73619 5.35413 6.85425 6.10413 6.10425C6.85413 5.35425 7.73607 4.7605 8.74996 4.323C9.76385 3.8855 10.8472 3.66675 12 3.66675C13.1527 3.66675 14.2361 3.8855 15.25 4.323C16.2638 4.7605 17.1458 5.35425 17.8958 6.10425C18.6458 6.85425 19.2395 7.73619 19.677 8.75008C20.1145 9.76397 20.3333 10.8473 20.3333 12.0001C20.3333 13.1529 20.1145 14.2362 19.677 15.2501C19.2395 16.264 18.6458 17.1459 17.8958 17.8959C17.1458 18.6459 16.2638 19.2397 15.25 19.6772C14.2361 20.1147 13.1527 20.3334 12 20.3334Z"
          fill={fillColor}
        />
      </svg>
    );

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.83329 13.8334L14.7083 7.95841L13.5416 6.79175L8.83329 11.5001L6.45829 9.12508L5.29163 10.2917L8.83329 13.8334ZM9.99996 18.3334C8.84718 18.3334 7.76385 18.1147 6.74996 17.6772C5.73607 17.2397 4.85413 16.6459 4.10413 15.8959C3.35413 15.1459 2.76038 14.264 2.32288 13.2501C1.88538 12.2362 1.66663 11.1529 1.66663 10.0001C1.66663 8.8473 1.88538 7.76397 2.32288 6.75008C2.76038 5.73619 3.35413 4.85425 4.10413 4.10425C4.85413 3.35425 5.73607 2.7605 6.74996 2.323C7.76385 1.8855 8.84718 1.66675 9.99996 1.66675C11.1527 1.66675 12.2361 1.8855 13.25 2.323C14.2638 2.7605 15.1458 3.35425 15.8958 4.10425C16.6458 4.85425 17.2395 5.73619 17.677 6.75008C18.1145 7.76397 18.3333 8.8473 18.3333 10.0001C18.3333 11.1529 18.1145 12.2362 17.677 13.2501C17.2395 14.264 16.6458 15.1459 15.8958 15.8959C15.1458 16.6459 14.2638 17.2397 13.25 17.6772C12.2361 18.1147 11.1527 18.3334 9.99996 18.3334Z"
        fill={fillColor}
      />
    </svg>
  );
};
